import * as yup from "yup";
import {
  validationNotEmpty,
} from "./defaultValidations";

export default yup.object({
  status: validationNotEmpty("Status"),
});
